import React, { Component } from 'react';
import { LoadScript } from '@react-google-maps/api';
import GoogleMaps from '../../client/components/googleMaps';
import { GOOGLE_MAP_API_KEY } from '../../api/api-config';

const GOOGLE_MAPS_LIBRARIES = ['places'];

class Maps extends Component {
  render () {
    return (
      <LoadScript
        id='visava-google-maps-script'
        googleMapsApiKey={GOOGLE_MAP_API_KEY}
        libraries={GOOGLE_MAPS_LIBRARIES}
      >
        <GoogleMaps />
      </LoadScript>
    );
  }
}

export default Maps;
